import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [opacity, setOpacity] = useState(1); // Initial opacity is fully visible

    // Function to handle scroll event
    function handleScroll() {
        const scrollY = window.scrollY;
        const maxFadeHeight = 150; // Adjust this value as needed
        const newOpacity = Math.max(1 - scrollY / maxFadeHeight, 0); // Calculate opacity
        setOpacity(newOpacity);
    }
    useEffect(() => {
        // Add event listener for scroll
        window.addEventListener('scroll', handleScroll);
        return () => {
            // Cleanup event listener on component unmount
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <nav
            className="navbar navbar-expand-lg py-0 sticky-top navbar-custom"
            style={{
                opacity: opacity, // Apply the opacity here
                transition: 'opacity 0.05s cubic-bezier(0.4, 0.3, 0.2, 0.1)', // Smoother transitions ease-in-out',
            }}
        >

            {/* For the logo on top left */}
            <div className='d-flex justify-content-between align-items-center'>
                <Link to="/" className='navbar-brand py-0 order-2 order-md-1'>
                    <img 
                        src="images/logo.png" 
                        alt="Logo" 
                        className="d-inline-block align-text-top icon" 
                        style={{ width: "150px", height: "150px" }} 
                    />
                </Link>
                {/* Navbar toggler on smaller screens */}
                <button className="navbar-toggler order-1 order-md-2" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
            </div>
            <div className="collapse navbar-collapse justify-content-end"
                id="navbarNav">
                {/* navbar items */}
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item"><Link className='nav-link' to="/">Home</Link></li>
                    <li className="nav-item"><Link className='nav-link' to="/bio">Professor C R Raj</Link></li>
                    <li className="nav-item"><Link className='nav-link' to="/publications">Publications</Link></li>
                    <li className="nav-item"><Link className='nav-link' to="/group-members">Group</Link></li>
                    <li className="nav-item"><Link className='nav-link' to="/electrochemistry">Electrochemistry</Link></li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            FME LAB
                        </a>
                        <ul className="dropdown-menu custom-dropdown-item dropdown-menu-end">
                            <li><Link className='nav-link' to="/lab-facilities">Lab Facilities</Link></li>
                            <li><Link className='nav-link' to="/materials-library">Materials Library</Link></li>
                            <li><Link className='nav-link' to="/gallery">Gallery</Link></li>

                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navbar;